class GAEvent{
    skip({rows,cols}){
        //https://developers.google.com/analytics/devguides/collection/gtagjs/events
        try{
            window.gtag('event', 'puzzle-skip', {
                'event_category' : 'engagement',
                'event_label' : `skip_${rows}x${cols}`
              });

              console.log('success on sending ga event skip');

        }catch(e){
            console.log('error on sending ga event skip',e);
        }

        
    }
    hint({rows,cols}){
        try{
            window.gtag('event', 'puzzle-hint', {
                'event_category' : 'engagement',
                'event_label' : `hint_${rows}x${cols}`
              });

              console.log('success on sending ga event hint');

        }catch(e){
            console.log('error on sending ga event hint',e);
        }

        
    }

    complete({rows,cols}){
        //https://developers.google.com/analytics/devguides/collection/gtagjs/events

        try{
            window.gtag('event', 'puzzle-complete', {
                'event_category' : 'engagement',
                'event_label' : `complete_${rows}x${cols}`
              });

            console.log('success on sending ga event puzzle complete');
        }
        catch(e){
            console.log('error on sending ga event puzzle complete',e);
        }

        
    }
    
}

export const gaEvent = new GAEvent();